import api from "../services/admin_api_global";

const ok = (r) => ({ status: r.status, data: r.data });
const err = (e) => ({ status: e.response?.status || 500, message: e.response?.data?.message || "Failed" });

// ── Categories ────────────────────────────────────────────────────────────────
export const fetchGdCategories = () => api.get("/admin/gd/categories").then(ok).catch(err);
export const createGdCategory = (p) => api.post("/admin/gd/categories", p).then(ok).catch(err);
export const updateGdCategory = (id, p) => api.put(`/admin/gd/categories/${id}`, p).then(ok).catch(err);
export const deleteGdCategory = (id) => api.delete(`/admin/gd/categories/${id}`).then(ok).catch(err);

// ── Topics ────────────────────────────────────────────────────────────────────
export const fetchGdTopics = (params) => api.get("/admin/gd/topics", { params }).then(ok).catch(err);
export const fetchGdTopicById = (id) => api.get(`/admin/gd/topics/${id}`).then(ok).catch(err);
export const createGdTopic = (p) => api.post("/admin/gd/topics", p).then(ok).catch(err);
export const updateGdTopic = (id, p) => api.put(`/admin/gd/topics/${id}`, p).then(ok).catch(err);
export const deleteGdTopic = (id) => api.delete(`/admin/gd/topics/${id}`).then(ok).catch(err);
export const updateGdTopicStatus = (id, status) =>
  api.patch(`/admin/gd/topics/${id}/status`, { status }).then(ok).catch(err);

// ── Links ─────────────────────────────────────────────────────────────────────
export const addGdTopicLink = (topicId, p) => api.post(`/admin/gd/topics/${topicId}/links`, p).then(ok).catch(err);
export const deleteGdTopicLink = (topicId, linkId) =>
  api.delete(`/admin/gd/topics/${topicId}/links/${linkId}`).then(ok).catch(err);

// ── Comments ──────────────────────────────────────────────────────────────────
export const fetchAdminGdComments = (topicId, params) =>
  api.get(`/admin/gd/topics/${topicId}/comments`, { params }).then(ok).catch(err);
export const replyAdminGdComment = (topicId, commentId, commentText) =>
  api.post(`/admin/gd/topics/${topicId}/comments/${commentId}/reply`, { commentText }).then(ok).catch(err);
export const deleteAdminGdComment = (topicId, commentId) =>
  api.delete(`/admin/gd/topics/${topicId}/comments/${commentId}`).then(ok).catch(err);
